import { AuthSession } from '@hourly/contexts/AuthContext';
import { useRequest } from '@hourly/hooks/useRequest';
import Partner from '~/routes/__auth/_shared/data/models/partner.model';
import User from '~/routes/__auth/_shared/data/models/user.model';
import { switchUserRequest } from '~/routes/__auth/_shared/data/requests/auth.request';
import { verifyDirectLogin } from '../requests/verifyDirectLogin.request';

interface UseDirectLoginProps {
  hourlyToken: string;
  partnerId: string;
  session: AuthSession;
  logout: () => Promise<void>;
  onSuccess: ({ user, partner }: { user: User; partner: Partner }) => void;
  onError?: (error: unknown) => void;
}

export const useDirectLogin = ({
  hourlyToken,
  partnerId,
  session,
  logout,
  onSuccess,
  onError,
}: UseDirectLoginProps) => {
  const { request: directLogin } = useRequest(
    async (token: string | null) => {
      if (token) {
        const hasAPreviousSession = !!session.userId;
        if (hasAPreviousSession) {
          await logout();
        }

        await verifyDirectLogin(token);
        const { user, partner } = await switchUserRequest(partnerId);

        if (!partner.isDirectLoginAllowed) {
          throw new Error('Direct login not allowed for this partner');
        }

        onSuccess?.({ user, partner });
      }
    },
    { requestOnMount: !!hourlyToken && !!partnerId, initialParams: hourlyToken, onError }
  );

  return { directLogin };
};
